import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiSummarizeFeedback(commentsBlob: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are a project manager summarizing client feedback. Group by theme (positive · change request · question · risk). Be tight: 1 sentence per theme bullet. Markdown.`;
  try {
    await streamGroq({ messages: [{ role: 'system', content: system }, { role: 'user', content: commentsBlob }], temperature: 0.3, onStream });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) { onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙.'); return; }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
